import { Dispatch } from 'redux';
import { ThunkAction } from 'redux-thunk';
import * as actionTypes from './types';
import { getSelfCapabilities } from '../../service/capability.service';

type AppThunk<ReturnType = void> = ThunkAction<ReturnType, any, unknown, any>;

/**
 * Fetches the caller's own resolved capability row for a node (organisation, entity or
 * workspace; the endpoint accepts any). The auth fetchUser thunk calls it for the
 * default workspace as the active node; consoles and switchers pass active: false so
 * peeking at another node never changes what the rest of the app is gated on.
 */
export const fetchCapabilities =
  (nodeId: number, { active = true }: { active?: boolean } = {}): AppThunk =>
    async (dispatch: Dispatch) => {
      dispatch({ 
        type: actionTypes.FETCH_CAPABILITIES_LOADING, 
        payload: { nodeId, active } 
      });
      try {
        const data = await getSelfCapabilities(nodeId);
        dispatch({
          type: actionTypes.FETCH_CAPABILITIES_SUCCESS,
          payload: { data, nodeId, active }
        });
      } catch (error) {
        console.error('Failed to fetch capabilities', error);
        dispatch({ 
          type: actionTypes.FETCH_CAPABILITIES_FAILED, 
          payload: { nodeId, active } 
        });
      }
    };
